export enum EMPTY_STATE_VARIANTS {
  DEFAULT = 'default',
  WITH_BORDERED_CONTAINER = 'with-bordered-container',
  ILLUSTRATION_TWO_COL = 'illustration-two-col',
}
